export default "__VITE_ASSET__CENqJJ45__"